import createHttp from '@/config/http';
import type {
	BVApprovedPatient,
	Patients,
	PatientsResponse,
} from '@/types/patient';
import type { ResponseMetaData } from '@/types/service';

// localhost:3003
const http = createHttp(import.meta.env.VITE_PATIENT_URL);

export const getPatients = async (
	page = 1,
	limit = 15,
	columnsFilters = '[]',
	search = '',
	status = '',
	globalFilters = '[]',
	sort = '',
): Promise<{
	items: Patients[];
	meta: ResponseMetaData;
}> => {
	const response = await http.get<PatientsResponse>('/patients/db', {
		params: {
			page,
			limit,
			columnsFilters,
			search,
			status,
			globalFilters,
			sort,
		},
	});
	return {
		items: response.data.data.items,
		meta: response.data.data.metaData,
	};
};

export const getPatientsAi = async (
	page = 1,
	limit = 15,
	search = '',
	clinicId = '',
): Promise<{
	items: Patients[];
	meta: ResponseMetaData;
}> => {
	const response = await http.get<PatientsResponse>('/patients/db/ai', {
		params: {
			page,
			limit,
			search,
			clinicId
		},
	});
	return {
		items: response.data.data.items,
		meta: response.data.data.metaData,
	};
};

export const getPatient = async (id: string): Promise<Patients> => {
	const response = await http.get<{ data: Patients }>(`/patients/db/${id}`);
	return response.data.data;
};

export const createPatient = async (patientData: any): Promise<Patients> => {
	// Extract insurance data to exclude from API call
	const { primaryInsurance, secondaryInsurance, ...apiPayload } = patientData;
	
	const response = await http.post<{ data: Patients }>(
		'/patients',
		apiPayload,
	);
	return response.data.data;
};

export const updatePatient = async (
	id: string,
	patientData: any,
): Promise<Patients> => {
	const response = await http.patch<{ data: Patients }>(
		`/patients/${id}`,
		patientData,
	);
	return response.data.data;
};

export const getPatientsWithApprovedBV = async (
	page = 1,
	limit = 15,
	search = '',
	sort = '',
	globalFilters = '[]',
): Promise<{
	items: BVApprovedPatient[];
	meta: ResponseMetaData;
}> => {
	const response = await http.get<{
		data: { items: BVApprovedPatient[]; metaData: ResponseMetaData };
	}>('/patients/bv-approved', {
		params: {
			page,
			limit,
			search,
			sort,
			globalFilters,
		},
	});
	return {
		items: response.data.data.items,
		meta: response.data.data.metaData,
	};
};

export const getPatientsWithApprovedBVAi = async (
	page = 1,
	limit = 15,
	search = '',
	clinicId = '',
): Promise<{
	items: BVApprovedPatient[];
	meta: ResponseMetaData;
}> => {
	const response = await http.get<{
		data: { items: BVApprovedPatient[]; metaData: ResponseMetaData };
	}>('/patients/bv-approved/ai', {
		params: {
			page,
			limit,
			search,
			clinicId
		},
	});
	return {
		items: response.data.data.items,
		meta: response.data.data.metaData,
	};
};